import React from 'react'
import { Typography, Box } from '@material-ui/core'

type TitleProps = {
  children: string
}

const Title: React.FC<TitleProps> = props => {
  return (
    <Box mb={2}>
      <Typography component="h2" variant="h5" color="primary" paragraph>
        {props.children}
      </Typography>
    </Box>
  )
}

export default Title
